module.exports = __webpack_public_path__ + "img/SC4-income.3adb8608.png";